import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';

@Injectable()
export class NetworkConnectionService {

  private connectionMonitor: Observable<boolean>;

  constructor() {
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    this.connectionMonitor = merge(
      offline$, online$
    );
  }

  monitor(): Observable<boolean> {
    return this.connectionMonitor;
  }
}
